import React, { useEffect, useMemo, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import { Cookies } from 'react-cookie';

import Navbar from './NavBar';
import { Card, Header, Footer, Loader } from 'components';
import { logout } from 'store/actions';
import { BASE_URL, DISABILITY, ADMIN_LOGIN_URL, AREP_LOGIN_URL, POB_LOGIN_URL, FOREIGN_USER } from '../constants';
import axios from 'axios';


export const Dashboard = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const [loading, setLoading] = useState(true);

    const fontSize = useSelector(state => state.layout.fontSize);
    const securityLvl = localStorage.getItem("securityLvl");
    const isAuthenticated = useSelector(state => state.authentication.isAuthenticated);
    const userData = useSelector(state => state.authentication.userData);
    const subjectData = useSelector(state => state.authentication.subjectData);

    const constructLogoutUrl = useMemo(() => {
        return `${BASE_URL}/nias/application/logout`;
    }, []);

    const changeEntityUrl = encodeURIComponent(
        `${BASE_URL}/e-ovlastenja/promjena-subjekta?ForPersonOib={ForPersonOib}&ForLegalIps={ForLegalIps}&ForLegalIzvor_reg={ForLegalIzvor_reg}&ToLegalIps={ToLegalIps}&ToLegalIzvor_reg={ToLegalIzvor_reg}`
    );

    const addQueryParams = () => {
        const cookies = new Cookies(document.cookie);
        const params = `?jwt=${cookies.get('token')}`; //&niasName=${cookies.get('niasName')}&niasSessionIndex=${cookies.get('niasSessionIndex')}
        return params;
    }

    const handleLogout = () => {
        console.log("loging out");
        dispatch(logout(()=> navigate('/logedout')))
    }

    const handleVisionImapired = (isImpaired) => {
        dispatch({
            type:DISABILITY,
            payload: isImpaired,
        })
    }
    const handleDyslexia = (isDyslexic) => {
        dispatch({
            type:"DYSLEXIA",
            payload: isDyslexic,
        })
    }

    const handleCondition = (role) => {
        if(userData.authorities.length){
            return userData.authorities.filter(({authority}) => authority === role).length
        }else{
            return false;
        }
    }

    const handleBtnPotvrdite = () => {
        setLoading(true);
    }

    const redirectOrReauthenticat = (minSecurityLvl, redirectLocation) => {
        if(securityLvl >= minSecurityLvl){
            window.location.replace(redirectLocation + addQueryParams());
        }else{
            window.location.replace(`${BASE_URL}/nias/reauthenticate`);
        }
    }

    const checkIfSessionInvalidated = async () => {
        try{
            const response = await axios.get(`${BASE_URL}/navigation/checkIfSessionInvalidated`,{
                headers:{
                    Authorization: 'Bearer ' +  localStorage.getItem("token")
                },
            });
            if(response.data){
                navigate('/logedout');
            }
        }catch(e){
            console.log(e);
        }
        return false;
    }

    useEffect(()=>{
            if(!isAuthenticated){
                navigate('/');
            }else{
                if(location.state?.redirect){
                    if(handleCondition("ROLA_ADMIN") || handleCondition("ROLA_NADZORNIK_JPT") || handleCondition("ROLA_NADZORNIK_SUSTAVA") || handleCondition("ROLA_KORISNIK")){
                        redirectOrReauthenticat("4",AREP_LOGIN_URL);
                    }else if(handleCondition("ADMIN")  || handleCondition("NADZOR") || handleCondition("SUPERVIZOR") || handleCondition("PODRSKA")){
                        redirectOrReauthenticat("4",ADMIN_LOGIN_URL);
                    }else if(handleCondition("ROLA_KORISNIK_GRADANSKA")){
                        redirectOrReauthenticat("2",POB_LOGIN_URL);
                    }
                }
            }

            setInterval(()=>{
               const temp = checkIfSessionInvalidated();
               console.log(temp);
            },40000)
    },[]);

    useEffect(()=>{
        if(location.state?.redirect){
            setLoading(true);
        }else{
            if(userData && userData.userIdentType === FOREIGN_USER){    
                if(handleCondition("ROLA_KORISNIK_GRADANSKA")){
                    redirectOrReauthenticat("2",POB_LOGIN_URL);
                }
            }else{
                setLoading(false);
            }
        }
    }, [location]);

    return (
        loading ? <Loader /> :
        <>
            <div className="grid-container">
                <div>
                    <Navbar
                        messageId={userData?.inResponseTo}
                        navToken= {userData?.navToken} 
                        logoutUrl= {constructLogoutUrl}
                        loginUrl={`${BASE_URL}/nias`}
                        isAuthenticated = {isAuthenticated}
                        changeEntityUrl={changeEntityUrl}
                        logout={handleLogout}
                        forLegalIps={subjectData?.forLegalIps}
                        forLegalIzvor={subjectData?.forLegalIzvor}
                        forPersonOib={subjectData?.forPersonOib} 
                        toLegalIps={subjectData?.toLegalIps}
                        toLegalIzvor={subjectData?.toLegalIzvor}
                        handleVisionImpaired={handleVisionImapired}
                        handleDyslexia={handleDyslexia}
                        hideEntitySearch={true}
                        handleBtnPotvrdite = {handleBtnPotvrdite}
                        test
                    />
                    <Header />
                    <span className={`text-impaired font${fontSize}`}>
                        <h2>{userData?.firstName} {userData?.lastName}, dobro došli na uslugu e-Pristojbe,</h2>
                        <p style={{marginLeft:"50px"}}>molimo izaberite subjekt koji želite zastupati u sustavu.</p>
                    </span>
                </div>
                <div>
                    {/*
                     <div className='wrapper'>
                        <Card href={ADMIN_URL} title = 'Modul za upravljanje matičnim podacima' hidden = {!handleCondition("4","ADMINISTRATIVNA")} />
                        <Card href={AREP_URL + addQueryParams()} title = 'Modul korisničkog sučelja za tijela javne vlasti' hidden = {!handleCondition("4","OPERATIVNA")}/>
                        <Card href={POB_URL + addQueryParams()} title = 'Modul korisničkog sučelja za pristojbene obveznike' />    
                    </div> 
                */}
                </div>
                <div>
                    <Footer />
                </div>
            </div>
        </>
  )
}
